const cardsGroupsWithHistoricalObservationsReducer = (data = [], action) => {
    switch(action.type){
        case 'SET_CARDS_GROUPS_WITH_HISTORICAL_OBSERVATIONS':
            data = action.data
            return  data;
        default:
            return data;
    }
}

export default cardsGroupsWithHistoricalObservationsReducer;